import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Posez-vous des fenêtres neuves ?',
      answer: 'Non, nous ne posons pas de fenêtres neuves. Notre métier est exclusivement la réparation et l\'entretien de fenêtres existantes. Nous ne sommes pas des vendeurs de menuiseries, nous sommes des techniciens spécialisés dans la remise en état. Si votre fenêtre n\'est vraiment pas réparable (moins de 10% des cas), nous vous orientons vers un poseur qualifié.',
    },
    {
      question: 'Ma fenêtre est-elle réparable ou faut-il la remplacer ?',
      answer: 'Dans 90% des cas, une fenêtre est réparable ! Mécanisme bloqué, poignée cassée, joint défectueux, vitrage fissuré : la plupart des problèmes ont une solution de réparation. Nous effectuons un diagnostic gratuit pour évaluer l\'état de votre fenêtre et vous proposer la meilleure solution. Réparer coûte 3 à 5 fois moins cher que remplacer.',
    },
    {
      question: 'Combien coûte une réparation de fenêtre à Lyon ?',
      answer: 'Le coût dépend du type de réparation : remplacement d\'une poignée (80-150€), changement de crémone (150-300€), réparation de mécanisme (200-400€), changement de joints (100-250€). C\'est 3 à 5 fois moins cher qu\'une fenêtre neuve (800-1500€). Consultez notre <a href="/blog/prix-reparation-fenetre-lyon-2025" class="text-teal-600 hover:text-teal-700 underline font-medium">guide des prix 2025</a> pour plus de détails.',
    },
    {
      question: 'Intervenez-vous rapidement en cas d\'urgence ?',
      answer: 'Oui ! Nous intervenons sous 24h pour les réparations urgentes (fenêtre bloquée, problème de sécurité). Grâce à notre stock permanent de plus de 500 pièces détachées, nous réparons votre fenêtre le jour même dans 85% des cas, sans attendre de commande.',
    },
    {
      question: 'Quelles marques de quincaillerie réparez-vous ?',
      answer: 'Nous réparons toutes les marques : Ferco, Roto, Siegenia, GU, Winkhaus, Maco, et bien d\'autres. Notre stock permanent contient plus de 500 références de pièces détachées. Si nous n\'avons pas la pièce en stock, nous la commandons et intervenons sous 48-72h.',
    },
    {
      question: 'Vos réparations sont-elles garanties ?',
      answer: 'Oui, toutes nos réparations sont garanties 2 ans pièces et main-d\'œuvre. Nous utilisons exclusivement des pièces de qualité professionnelle pour assurer la durabilité de nos interventions. Une réparation bien faite prolonge la durée de vie de votre fenêtre de 10 à 15 ans minimum.',
    },
    {
      question: 'Puis-je améliorer l\'isolation en réparant ma fenêtre ?',
      answer: 'Absolument ! Le remplacement des joints d\'étanchéité, le réglage des ouvrants et la réparation des systèmes de fermeture permettent de restaurer l\'isolation d\'origine. C\'est souvent suffisant pour retrouver un bon confort thermique et phonique, sans avoir à changer toute la fenêtre.',
    },
    {
      question: 'Faites-vous de l\'entretien préventif ?',
      answer: 'Oui, nous proposons des contrats d\'entretien préventif pour prolonger la durée de vie de vos fenêtres. Nettoyage, lubrification, réglage, vérification des joints : un entretien régulier évite 80% des pannes et prolonge la durée de vie de vos menuiseries de 10 à 15 ans.',
    },
  ];

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
            QUESTIONS FRÉQUENTES
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-4 mb-6">
            Tout Savoir sur la Réparation de Fenêtres
          </h2>
          <p className="text-lg text-gray-600">
            Les réponses à vos questions sur nos services de réparation
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-gray-50 rounded-2xl overflow-hidden border border-gray-200 hover:border-teal-300 transition-all duration-300 card-hover animate-fade-in-up delay-${(index + 1) * 100}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full bg-teal-100 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-teal-600 text-xl"></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p
                    className="text-gray-700 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 border border-teal-100 animate-fade-in-up delay-600 hover-lift">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Vous avez une autre question ?
          </h3>
          <p className="text-gray-600 mb-6">
            Contactez-nous pour un diagnostic gratuit et des conseils personnalisés sur la réparation de vos fenêtres.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center space-x-3 bg-teal-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-teal-700 transition-all hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer btn-ripple"
          >
            <i className="ri-customer-service-2-line text-xl"></i>
            <span>Nous Contacter</span>
          </a>
        </div>
      </div>

      {/* Schema.org FAQPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer.replace(/<[^>]*>/g, '')
            }
          }))
        })
      }} />
    </section>
  );
}
